import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import { useDisplayCurrency } from '../../context/displayCurrencyContext';
import { DISPLAY_CURRENCY_USD } from '../../util/displayCurrency';

import css from './CurrencyChargeNotice.module.css';

/**
 * Clarifies that Stripe charges in EUR. Shown only when the buyer prefers USD
 * so EUR-only viewers are not shown redundant estimate copy.
 * USD estimate of the total lives under OrderBreakdown total (single owner).
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className]
 * @param {'upcoming'|'past'} [props.tense='upcoming'] - Charge copy tense
 * @returns {JSX.Element|null}
 */
const CurrencyChargeNotice = props => {
  const { className, tense = 'upcoming' } = props;
  const { displayCurrency } = useDisplayCurrency();

  if (displayCurrency !== DISPLAY_CURRENCY_USD) {
    return null;
  }

  const chargeMessageId =
    tense === 'past'
      ? 'CurrencyChargeNotice.chargedInEurPast'
      : 'CurrencyChargeNotice.chargedInEur';

  return (
    <div className={classNames(css.root, className)} role="note">
      <p className={css.line}>
        <FormattedMessage id={chargeMessageId} />
      </p>
      <p className={css.line}>
        <FormattedMessage id="CurrencyChargeNotice.estimatesDisclaimer" />
      </p>
    </div>
  );
};

export default CurrencyChargeNotice;
